// extracted by mini-css-extract-plugin
export default {"root":"root--F4aft","link":"link--F4aft","inverse":"inverse--F4aft"};